import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";

import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import sidebarMenu from "../../../constants/sidebar";
import useMobile from "../../../hooks/useMobile";
import Header from "./Header";
import "./style.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AcctokenD, logout, RefftokenD } from "../../../store/actions";
import { removeDashboard } from "../../../store/reducers/dashboardReducer";
import { resetProfile } from "../../../store/reducers/userProfileReducer";
import { removePayment } from "../../../store/reducers/paymentReducer";
import { isAdmin } from "../../../store/reducers/adminReducer";
import { ReactComponent as MiniLogoIcon } from "../../../assets/icons/Sidebar/MiniLogoIcon.svg";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

export default function MiniDrawer(props) {
  const dispatch = useDispatch();
  const isMobile = useMobile();
  const [open, setOpen] = React.useState(false);
  let location = useLocation();
  const navigate = useNavigate();
  const { theme } = useSelector((state) => state.theme);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const HandleLogout = (e) => {
    e.preventDefault();
    dispatch(AcctokenD(0));
    dispatch(RefftokenD(0));
    dispatch(removeDashboard());
    dispatch(resetProfile());
    dispatch(removePayment());
    dispatch(isAdmin(false));
    dispatch(logout());
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Header
        open={open}
        handleDrawerOpen={handleDrawerOpen}
        headerTitle={props.headerTitle}
      />
      <SwipeableDrawer
        className={
          open ? "open-st sidebarMenuSection" : "close-st sidebarMenuSection"
        }
        open={open}
        anchor="left"
        variant={isMobile ? "temporary" : "permanent"}
        onClose={handleDrawerClose}
        onOpen={handleDrawerOpen}
        onMouseOver={handleDrawerOpen}
        onMouseLeave={handleDrawerClose}
      >
        <DrawerHeader key={"dr-header"} className="logoContainer">
          <MiniLogoIcon style={{ width: "45px", height: "45px" }} />
        </DrawerHeader>
        <List
          className="side-menu-ctn sideBarMenuContainer"
          key={"drawer-list"}
        >
          {sidebarMenu.map((item, idx) => {
            return (
              <ListItem
                key={idx + "-mini"}
                disablePadding
                sx={{
                  display: "block",
                  mt: item.label === "Profile" && "auto",
                }}
                className={
                  location.pathname.search(item.url) !== -1 ||
                  (location.pathname.search("/CompetitionOverview") !== -1 &&
                    item.url === "/competitionlist")
                    ? "menuButton active-menu"
                    : "menuButton"
                }
              >
                {item.label === "Logout" || item.label === "Profile" ? (
                  <ListItemButton
                    className={`menuBtn ${
                      item.label === "Logout" ? "logoutBtn" : "ProfileBtn"
                    }`}
                    onClick={
                      item.label === "Logout"
                        ? HandleLogout
                        : () => navigate("/profile")
                    }
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                      className="menuBtnIcon"
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText
                      primary={item.label}
                      sx={{ opacity: open ? 1 : 0 }}
                      className="menuBtnText"
                    />
                  </ListItemButton>
                ) : (
                  <Link to={item.url} key={idx}>
                    <ListItemButton
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                        }}
                        className="menuBtnIcon"
                      >
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={item.label}
                        sx={{ opacity: open ? 1 : 0 }}
                        className="menuBtnText"
                      />
                    </ListItemButton>
                  </Link>
                )}
              </ListItem>
            );
          })}
        </List>
      </SwipeableDrawer>
      <Box
        component="main"
        className="mainContentSection"
        sx={{ flexGrow: 1, py: 2, ml: isMobile ? 0 : 10 }}
      >
        {/* <DrawerHeader /> */}
        {props.children}
      </Box>
    </Box>
  );
}
